import * as Yup from "yup";

export const generatePaymentLinkSchema = Yup.object().shape({
  code: Yup.string().required("Code is required"),
  plan_variants: Yup.object().required("Variant is required"),
  type: Yup.string().required("Type is required"),
});
